import { render, staticRenderFns } from "./Riskmatrix.vue?vue&type=template&id=2426dfe4&scoped=true"
var script = {}
import style0 from "./Riskmatrix.vue?vue&type=style&index=0&id=2426dfe4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2426dfe4",
  null
  
)

export default component.exports